<template>
    <div id="price-chart">
        <v-chart :options="graph"/>
    </div>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

export default {
  name: 'price',
  components: {'v-chart': ECharts},
  props: ['headers','data'],
  data() {
    return {
      graph :{
        title: {
          show: true,
          text: 'Evolución de precios',
        },

        tooltip: {
          show: true
        },
        textStyle: {
          fontFamily: 'Gotham',
          color: '#888'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.headers
        },
        yAxis: {
          type: 'value',
          name: this.data[0],
          min: function(element) {
            return Math.round(element.min - (element.min * 0.02));
          },
          max: function(element) {
            return Math.ceil(element.max + (element.max * 0.02));
          }
        },
        series: [{
          name: 'Precio',
          data: this.data.slice(1),
          type: 'line',
          areaStyle: {
            color:'#47A44A'
          },
          lineStyle: {
            color:'#47A44A'
          },
          itemStyle: {
            color:'#0A61AD'
          }
        }]
      }
    }
  }

}
</script>
<style>
#price-chart .echarts {
  width: 100%;
  height: 400px;
}
</style>
